import React from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { getSelectedStore } from 'x/redux/selectors'

import { TouchableOpacity, View } from 'react-native'

import p from 'x/config/platform-specific'
import CONS from 'x/config/constants'
import * as util from 'x/utils/util'
import * as api from 'x/utils/api'
import { COLORS, S } from 'x/config/styles'
import {
  ICrmChannelListViewProps,
  ICrmChannelListViewState,
  ISearchProductItem,
  IBarcodeScannerOutput,
  ISearchProductVariantListViewNavParams,
  IXSegmentOption,
  ISearchInventoryProductsParams,
  IQtyAdjustReason,
  ICrmChannel,
} from 'x/types'

// import BackIcon from 'xui/components/BackIcon'
import VStack from 'xui/components/VStack'
import XText from 'xui/components/XText'
import XContent from 'xui/components/XContent'
import XContainer from 'xui/components/XContainer'
import XCustomHeader from 'xui/components/XCustomHeader'
import * as NavActions from 'x/utils/navigation'
import HStack from 'xui/components/HStack'
import XImage from 'xui/components/XImage'
import XIconButton from 'xui/components/XIconButton'
import XIcon from 'xui/components/XIcon'
import XCard from 'xui/components/XCard'
import XSpinner from 'xui/components/XSpinner'
import ForwardIcon from 'xui/components/ForwardIcon'
import CrmLogo from 'xui/components/CrmLogo'

class CrmChannelListView extends React.Component<ICrmChannelListViewProps, ICrmChannelListViewState> {
  static displayName = 'CrmChannelListView'

  _inProcess?: boolean

  constructor(props: ICrmChannelListViewProps) {
    super(props)
    this.state = {
      isInitialized: false,
      isRefreshing: false,
      crmChannels: [],
    }
  }

  async componentDidMount() {
    await this._initializeView()
    await util.delay(200)
    await this._fetchCrmChannels()
  }

  _initializeView = async () => {
    await util.setStatePromise(this, { isInitialized: false, products: [], selectedReason: null })
    // Init activeStatesMap
    const newState: Partial<ICrmChannelListViewState> = {}
    // get ready to render
    newState.isInitialized = true

    await util.setStatePromise(this, newState)
  }

  _fetchCrmChannels = async () => {
    if (this._inProcess) {
      return
    }
    this._inProcess = true
    await util.setStatePromise(this, { isRefreshing: true })

    const storeId = util.getNavParam(this.props, 'store_id')
    try {
      const res = await api.getCrmChannelList({
        store_id: storeId,
      })

      if (res && res.crm_channels) {
        await util.setStatePromise(this, { crmChannels: res.crm_channels })
      }
    } catch (err) {
      console.log('CrmChannelListView::_fetchCrmChannels:: err => ', err)
    }

    await util.setStatePromise(this, { isRefreshing: false })
    this._inProcess = false
  }

  _goBack = () => {
    util.navGoBack(this.props)
  }

  _onCrmChannelCreatedSuccess = (newCrmChannel: ICrmChannel) => {
    // refresh list
    this._fetchCrmChannels()
  }

  _navToCrmChannelCreateView = () => {
    const { navigation } = this.props
    const store_id = util.getNavParam(this.props, 'store_id')

    navigation.dispatch(
      NavActions.navToCrmChannelCreateView({
        store_id,

        onCreatedSuccess: this._onCrmChannelCreatedSuccess,
      })
    )
  }

  _renderCustomHeader = () => {
    const isGoBackButtonHidden = util.getNavParam(this.props, 'isGoBackButtonHidden', false)

    return (
      <XCustomHeader
        title={p.op.t('crm.channelListView.title')}
        headerLeftProps={isGoBackButtonHidden ? undefined : { backIcon: true, onPressItem: this._goBack }}
        headerRightProps={{ addIcon: true, onPressItem: this._navToCrmChannelCreateView }}
      />
    )
  }

  _onCrmChannelUpdatedSuccess = (updatedCrmChannel: ICrmChannel) => {
    const { crmChannels } = this.state

    const updatedCrmChannels = crmChannels.map((crmChannel) => {
      if (crmChannel.id === updatedCrmChannel.id) {
        return updatedCrmChannel
      }
      return crmChannel
    })

    this.setState({ crmChannels: updatedCrmChannels })
  }

  _onCrmChannelDeletedSuccess = (deletedCrmChannelId: number) => {
    const { crmChannels } = this.state

    const updatedCrmChannels = crmChannels.filter((crmChannel) => crmChannel.id !== deletedCrmChannelId)

    this.setState({ crmChannels: updatedCrmChannels })
  }

  navToCrmChannelDetailView = (crmChannel: ICrmChannel) => {
    const { navigation } = this.props
    const store_id = util.getNavParam(this.props, 'store_id')

    navigation.dispatch(
      NavActions.navToCrmChannelDetailView({
        store_id,
        crm_channel_id: crmChannel.id,

        onCrmChannelUpdated: this._onCrmChannelUpdatedSuccess,
        onCrmChannelDeleted: this._onCrmChannelDeletedSuccess,
      })
    )
  }

  _renderCrmChannelListItem = (crmChannel: ICrmChannel) => {
    return (
      <XCard key={`crm-channel-list-item-${crmChannel.id}`} onPress={() => this.navToCrmChannelDetailView(crmChannel)}>
        <HStack w='full' p='3' alignItems='center' space='1.5'>
          <CrmLogo crmSystemId={crmChannel.crm_system_id} width={34} height={34} />

          <HStack flex={1} alignItems='center'>
            <XText bold>{crmChannel.name}</XText>
          </HStack>

          <HStack w='34px' alignItems='center' justifyContent='flex-end'>
            <ForwardIcon />
          </HStack>
        </HStack>
      </XCard>
    )
  }

  _renderContent = () => {
    const { isInitialized, isRefreshing, crmChannels } = this.state
    if (!isInitialized) {
      return null
    }

    if (isRefreshing) {
      return (
        <VStack w='full' p='2'>
          <XSpinner />
        </VStack>
      )
    }

    return (
      <VStack w='full' p='2' space='1.5'>
        {crmChannels.map(this._renderCrmChannelListItem)}
      </VStack>
    )
  }

  render() {
    return (
      <XContainer>
        {this._renderCustomHeader()}
        <XContent>{this._renderContent()}</XContent>
      </XContainer>
    )
  }
}

export default connect(
  (state) => ({
    selectedStore: getSelectedStore(state),
  }),
  (dispatch) => ({
    dispatch,
  })
)(CrmChannelListView)
